export default {"src":"/_next/static/media/logout.9487e04f.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};